module.exports = __webpack_public_path__ + "static/media/loading.b6afecc6.gif";